import { html as m, when as e } from "@microsoft/fast-element";
import { outlineHeroIconTemplate as t } from "./heroicons/outline.js";
import { solidHeroIconTemplate as r } from "./heroicons/solid.js";
import { miniHeroIconTemplate as i } from "./heroicons/mini.js";
import { microHeroIconTemplate as p } from "./heroicons/micro.js";
import { customIconTemplate as n } from "./custom/icon.template.js";
import { isCustomIcon as l } from "./custom/index.js";
const $ = m`
  <template aria-hidden="true">
    ${e(
  l,
  n,
  m`
        ${e((o) => o._type === "outline", t)}
        ${e((o) => o._type === "solid", r)}
        ${e((o) => o._type === "mini", i)}
        ${e((o) => o._type === "micro", p)}
      `
)}
  </template>
`;
export {
  $ as iconTemplate
};
